export const NOTIFICATION_TYPES = {
	INFO: 'info',
	SUCCESS: 'success',
	ERROR: 'error',
	WARNING: 'warning'
} as const;

export const NOTIFICATION_MESSAGES = {
	UNAVAILABLE: 'Şu anda birçok öğretmenimize yardımcı olmaya çalışıyoruz. 👩🏻‍🏫🧑🏻‍🏫‍ Birazdan tekrar dener misiniz?🙂 Teşekkürler! ⭐️',
	FEEDBACK_DELAY: 'Opi cevap vermeye devam ediyor 🚀 Cevabı bittiğinde değerlendirmeni gönderebilirsin! 💫',
	NO_CONVERSATIONS: 'Henüz hiç konuşma gerçekleştirmedin! 🚀 Yeni bir konuşma başlatarak Opi ile tanışabilirsin! 💫',
	OPI_RESPONDING: 'Dopi cevap vermeye devam ediyor 🚀 Cevabı bittiğinde yeni mesajını gönderebilirsin! 💫',
	LEGAL_TEXT_AVAILABLE: "Sorumluluk Reddi Beyanı'nı Opi'nin son mesajında görebilirsin! 👀",
	MESSAGE_DELAY: 'Opi cevap vermeye devam ediyor 🚀 Cevabı bittiğinde yeni mesajını gönderebilirsin! 💫',
	NO_USE_MOBILE_DEVICE:
		'Yapay zeka destekli ders araçlarımız şu anda yalnızca bilgisayar ve tablet üzerinden kullanılabilmektedir. Daha iyi bir deneyim için bilgisayar ya da tabletinizden erişim sağlayabilirsiniz.😊',
	GETTING_NEW_OPI_TABU_CARDS: 'Yeni OpiTabu kartlarını yüklüyoruz!',
	TOOL_DAILY_USAGE_ERROR: 'Bugün sizin için 100’den fazla içerik ürettik! 🎉 AI araçlarımızı yarın kullanmaya devam edebilirsiniz. İlginiz için teşekkür ederiz! 😊.',
	REFRESH_TOKEN_ERROR: 'Oturum Süreniz Dolmuştur.\n Tekrar Giriş Yapmanız Gerekiyor.',
	SAVE_SLOT_CHANGES: 'Randevu saatleriyle ilgili değişiklikler yaptınız. Slotlarınızın açık olduğu saatlerde bilgisayar başında olmanız gerekmektedir.',
	SAVE_SLOT_CHANGES_ERROR: 'Randevu saatleriyle ilgili değişiklikler yapılırken bir hata oluştu. Lütfen tekrar deneyin.',
	PASSWORD_SUCCESSFULLY_RESET: 'Şifreniz başarıyla güncellendi.',
	SOLVER_QUESTION_REPORT_SUCCESS: 'Raporlama yaptığınız soru operasyon ekibimiz tarafından incelenecektir.',
	SOLVER_QUESTION_REJECTED: 'Günde 10 soru reddetme hakkınız bulunmaktadır. Daha fazla soru çözebilmek için haklarınızı dikkatli kullanınız.'
} as const;

export const NOTIFICATION_TITLES = {
	SOLVER_QUESTION_REPORT_SUCCESS: 'Soru raporlandı!',
	SOLVER_QUESTION_REJECTED: 'Soru reddedildi!'
} as const;

export type NotificationType = (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];
export type NotificationMessage = (typeof NOTIFICATION_MESSAGES)[keyof typeof NOTIFICATION_MESSAGES];
